export const GRID_PAGES = [25, 50, 75, 100];
export const ROWS_PER_PAGE = 25;
export const DEFAULT_PAGE = 0;
